<div class="container" [attr.data-testid]="ELEMENT_IDS['cnt']">
  <div class="header mat-elevation-z1" [attr.data-testid]="ELEMENT_IDS['cnt_header']">
    <div class="title">
      <mat-icon>notifications</mat-icon>
      <h6 i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Notifications</h6>
    </div>
    <div class="actions">
      <button (click)="closeDrawer()" mat-icon-button [attr.data-testid]="ELEMENT_IDS['btn_close']">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="main-content" [attr.data-testid]="ELEMENT_IDS['cnt_summary']">
    <div class="sub-title">
      <h6>SUMMARY</h6>
      <mat-icon>notifications_active</mat-icon>
    </div>
    <div class="body">
      @for (summary of mockData; track summary; let si = $index){
      <div class="notif-item">
        <div class="notif-header">
          <mat-icon>{{ summary.icon }}</mat-icon>
          <h6>{{ summary.summaryTitle }}</h6>
        </div>
        <div class="notif-content">
          @for (item of summary.items; track item; let ii = $index){
          <div class="item">
            <div class="details">
              <h6>{{ item.label }}</h6>
              <div class="count">
                <p>{{ item.noOfDr }}</p>
              </div>
            </div>
            <div class="action">
              <app-custom-button
                [elementId]="ELEMENT_IDS['btn_view'] + '_' + si + '_' + ii"
                [disabled]="!item.noOfDr"
                buttonType="secondary"
                [density]="5"
                text="View"
              ></app-custom-button>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>
